<template>
  <div class="privacy-page">
    <section class="privacy-section">
      <div class="container">
        <div class="privacy-content">
          <h1>大连义韶科技有限公司隐私政策</h1>
          <p class="version-info">版本更新日期：2026 年 9 月 13 日 &nbsp; | &nbsp; 版本生效日期：2026 年 9 月 13 日</p>

          <p>大连义韶科技有限公司（以下简称 "我们"）深知个人信息对您的重要性，将按照法律法规要求，采取相应安全保护措施，保护您的个人信息安全可控。本隐私政策详细说明我们在收集、使用、存储、共享及保护您的个人信息方面的做法，适用于我们通过壹勺芯平台（网站及相关客户端）提供的所有服务。</p>

          <p>请您在使用我们的服务前，仔细阅读并充分理解本隐私政策的全部内容。当您点击 "同意" 按钮或开始使用我们的服务时，即表示您已充分理解并同意本隐私政策的全部内容。若您不同意本隐私政策的任何条款，请立即停止使用我们的服务。</p>

          <h2>一、我们如何收集和使用个人信息</h2>
          <p>我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：</p>

          <h3>（一）注册与账户管理</h3>
          <p><strong>1.基础注册信息：</strong>当您注册账户时，我们会收集您的手机号码、验证码，用于创建账户并验证您的身份。</p>
          <p><strong>2.实名认证信息：</strong>当您使用发布专利成果、申请金融服务、使用电子签章等高级功能时，我们会收集您的姓名、身份证号码（个人用户）或企业名称、统一社会信用代码、法定代表人信息（企业用户），用于完成实名认证，确保交易安全。</p>
          <p><strong>3.账户补充信息：</strong>您可以选择填写头像、简介、行业领域、联系方式等信息，这些信息将帮助其他用户更好地了解您，提高对接成功率。</p>

          <h3>（二）平台服务使用</h3>
          <p><strong>1.信息发布信息：</strong>当您在 "成果中心" 上传技术成果、在 "需求中心" 发布技术需求或在 "专家中心" 展示专业信息时，我们会收集您发布的所有内容，包括文字、图片、文档、视频等。</p>
          <p><strong>2.对接与交易信息：</strong>当您发起对接申请、预约专家服务或申请金融服务时，我们会收集您的对接意向、服务需求、交易记录、支付信息等，用于完成服务流程。</p>
          <p><strong>3.日志信息：</strong>当您使用我们的服务时，我们会自动收集您的设备信息（包括设备型号、操作系统版本、设备标识符）、IP 地址、访问时间、页面浏览记录、操作记录等日志信息，用于保障服务安全、优化用户体验。</p>
          <p><strong>4.位置信息：</strong>经您授权后，我们会收集您的地理位置信息，用于为您提供本地化的成果推荐和需求匹配服务。您可以随时在设备设置中关闭位置权限。</p>

          <h3>（三）金融服务</h3>
          <p>当您使用平台提供的金融服务对接功能时，我们会根据法律法规要求和金融机构的审核需要，收集您的银行账户信息、征信信息、财务状况信息等敏感个人信息。这些信息仅会用于金融服务的审核和办理，未经您的书面同意，我们不会将其用于任何其他目的。</p>

          <h3>（四）客服与售后</h3>
          <p>当您联系我们的客服时，我们会收集您的通信记录、账户信息、您提供的与问题相关的信息，用于处理您的咨询、投诉和建议。</p>

          <h3>（五）其他用途</h3>
          <p>1.我们可能会将收集的信息用于数据分析、产品优化、安全防范等目的，以不断提升我们的服务质量。</p>
          <p>2.若我们将信息用于本政策未载明的其他目的，会事先征得您的明确同意。</p>

          <h2>二、我们如何共享、转让和公开披露个人信息</h2>

          <h3>（一）信息共享</h3>
          <p>我们仅会在以下情况下，与第三方共享您的个人信息：</p>
          <p><strong>1.为促进对接共享：</strong>您同意我们将您在平台上公开的成果简介、需求标题、专家领域及您自行选择公开的联系方式共享给平台内的注册用户或潜在意向方，以实现精准匹配。</p>
          <p><strong>2.与合作服务商共享：</strong>我们可能会委托第三方服务商提供技术支持、支付结算、电子签章、物流配送等服务。我们仅会向第三方提供必要的信息，并要求第三方严格遵守保密义务，不得将信息用于任何其他目的。</p>
          <p><strong>3.法律合规共享：</strong>为配合行政监管机关、司法机关的合法要求，在法律法规允许的范围内，我们有权依法提供您的相关注册信息及行为日志。</p>
          <p><strong>4.与关联方共享：</strong>我们可能会与我们的关联方共享您的个人信息，但我们会要求关联方按照本隐私政策的要求保护您的个人信息。</p>

          <h3>（二）信息转让</h3>
          <p>未经您的明确同意，我们不会将您的个人信息转让给任何公司、组织或个人。但在涉及合并、收购、资产转让或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>

          <h3>（三）信息公开披露</h3>
          <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
          <p>1.获得您的明确同意后；</p>
          <p>2.基于法律的要求：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>

          <h2>三、我们如何存储和保护个人信息</h2>

          <h3>（一）信息存储</h3>
          <p><strong>1.存储地点：</strong>我们会将在中国境内收集和产生的个人信息存储在中国境内。</p>
          <p><strong>2.存储期限：</strong>我们只会在达成本政策所述目的所需的期限内保留您的个人信息。您的账户信息将在您使用平台服务期间持续留存，直至您注销账户。您发布的公开信息将在您删除或注销账户后立即从平台展示页面移除，但为了履行法律义务、解决纠纷或保障交易安全，我们可能会保留相关信息至必要期限届满。</p>
          <p><strong>3.数据删除：</strong>当我们的产品或服务发生停止运营的情形时，我们将及时停止继续收集个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并在合理期限内删除或匿名化处理您的个人信息。</p>

          <h3>（二）信息保护</h3>
          <p>1.我们将采取符合行业标准的技术措施和管理制度，保护您的个人信息安全，防止信息泄露、篡改、丢失。这些措施包括但不限于数据加密、访问控制、防火墙、入侵检测、定期安全审计等。</p>
          <p>2.我们建立了完善的数据安全管理制度，指定专门的个人信息保护负责人，对员工进行数据安全培训，明确员工的保密责任。</p>
          <p>3.若发生或可能发生个人信息安全事件，我们将立即启动应急预案，采取补救措施，并按照法律法规要求及时通知您和相关监管部门。通知方式包括但不限于短信、电子邮件或平台公告。</p>

          <h2>四、您的个人信息权利</h2>
          <p>您对您的个人信息享有以下权利：</p>
          <p><strong>1.查阅权：</strong>您有权查阅您在本平台的个人信息，包括账户信息、发布的信息、交易记录等。您可通过账户设置页面自行操作，或联系平台客服协助处理。</p>
          <p><strong>2.更正权：</strong>当您发现我们处理的关于您的个人信息有错误时，您有权要求我们更正。您可通过账户设置页面自行操作，或联系平台客服协助处理。</p>
          <p><strong>3.删除权：</strong>在以下情形下，您有权请求删除您的个人信息：</p>
          <p class="sub-item">（1）我们处理个人信息的目的已经实现、无法实现或者为实现处理目的不再必要；</p>
          <p class="sub-item">（2）我们违反法律、行政法规或者本隐私政策的约定处理个人信息；</p>
          <p class="sub-item">（3）您不再使用我们的服务，或者您注销了账户；</p>
          <p class="sub-item">（4）法律、行政法规规定的其他情形。</p>
          <p><strong>4.撤回同意权：</strong>您有权撤回对个人信息处理的同意。撤回同意后，我们将停止处理您的相关信息，但不影响此前基于您的同意已进行的信息处理活动的合法性。</p>
          <p><strong>5.复制权：</strong>您有权请求获取您的个人信息的副本。我们将按照法律法规的要求，为您提供个人信息的复制件。</p>
          <p><strong>6.注销权：</strong>您有权随时注销您的账户。您可通过账户设置页面提交注销申请，我们将在收到申请后 15 个工作日内完成审核并注销您的账户。账户注销后，我们将删除您的个人信息或进行匿名化处理，但法律法规另有规定的除外。</p>
          <p>我们将在收到您的权利请求后 15 个工作日内作出答复。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定的成本费用。</p>

          <h2>五、未成年人个人信息保护</h2>
          <p>1.我们非常重视未成年人的个人信息保护。未成年人注册使用本平台服务，必须在监护人的监护及同意下进行。</p>
          <p>2.对于经监护人同意收集的未成年人个人信息，我们只会在法律允许、监护人明确同意或者保护未成年人所必要的范围内使用或披露。</p>
          <p>3.若我们发现有未成年人未经监护人同意注册使用本平台服务，有权立即注销其账户，并删除相关个人信息。</p>
          <p>4.监护人发现未成年人擅自使用本平台服务或其个人信息被未经授权收集的，可联系平台客服申请注销账户或删除相关信息。</p>

          <h2>六、本政策的更新</h2>
          <p>1.我们可能会根据法律法规变化、业务发展需要或技术进步，适时更新本隐私政策。</p>
          <p>2.本隐私政策更新后，我们将在平台首页显著位置公示更新后的版本，并通过短信、电子邮件或平台公告等方式通知您。</p>
          <p>3.若您在本隐私政策更新后继续使用我们的服务，即表示您已充分理解并同意更新后的隐私政策。若您不同意更新后的内容，应立即停止使用我们的服务。</p>

          <h2>七、如何联系我们</h2>
          <p>如果您对本隐私政策有任何疑问、意见或建议，或者您需要行使您的个人信息权利，请通过以下方式联系我们：</p>
          <ul class="contact-list">
            <li>客服邮箱：kefu@yishaoxin.com</li>
            <li>联系电话：0411-XXXXXXXX</li>
            <li>联系地址：辽宁省大连市XX区XX路XX号大连义韶科技有限公司</li>
          </ul>
          <p>我们将在收到您的咨询后 15 个工作日内作出答复。</p>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>大连义韶科技有限公司</h3>
            <div class="social-links">
              <a href="#"><i class="fab fa-weixin"></i></a>
              <a href="#"><i class="fab fa-weibo"></i></a>
              <a href="#"><i class="fab fa-qq"></i></a>
              <a href="#"><i class="fab fa-linkedin"></i></a>
            </div>
          </div>
          <div class="footer-section">
            <h4>快速链接</h4>
            <ul>
              <li><router-link to="/achievement">成果中心</router-link></li>
              <li><router-link to="/demand">需求中心</router-link></li>
              <li><router-link to="/expert">专家中心</router-link></li>
              <li><router-link to="/partner">合作伙伴</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系我们</h4>
            <ul class="contact-info">
              <li><i class="fas fa-map-marker-alt"></i> xxxxxxxxx</li>
              <li><i class="fas fa-phone"></i> xxxxxxxx</li>
              <li><i class="fas fa-envelope"></i> xxxxxxxx</li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2026 大连义韶科技有限公司 版权所有 <span>|</span> <router-link to="/privacy">隐私政策</router-link> <span>|</span> <router-link to="/terms">使用条款</router-link></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.privacy-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.5715;
  color: rgba(0, 0, 0, 0.85);
  background-color: #f0f2f5;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

a { text-decoration: none; color: inherit; }
ul { list-style: none; }

/* 隐私政策内容 */
.privacy-section {
  padding: 48px 0;
  background: white;
}

.privacy-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.privacy-content h1 {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
}

.version-info {
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  margin-bottom: 4px;
}

.privacy-content > p {
  font-size: 15px;
  line-height: 1.8;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 16px;
  text-indent: 2em;
}

.privacy-content h2 {
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.privacy-content h3 {
  font-size: 16px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.75);
}

.privacy-content p strong {
  color: rgba(0, 0, 0, 0.85);
}

.privacy-content p.sub-item {
  padding-left: 2em;
  text-indent: 0;
  margin-bottom: 8px;
}

.contact-list {
  list-style: none;
  padding: 12px 20px;
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 16px;
}

.contact-list li {
  font-size: 15px;
  line-height: 2;
  color: rgba(0, 0, 0, 0.65);
}

/* 页脚 */
.footer {
  background: #fafafa;
  color: rgba(0, 0, 0, 0.85);
  padding: 48px 0 24px;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 48px;
  margin-bottom: 40px;
}

.footer-section h3, .footer-section h4 {
  font-weight: 600;
  margin-bottom: 20px;
}

.footer-section p {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  margin-bottom: 16px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-links a {
  width: 32px;
  height: 32px;
  background: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
}

.social-links a:hover {
  background: #1890ff;
  color: white;
}

.footer-section ul li {
  margin-bottom: 12px;
}

.footer-section ul li a {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  transition: all 0.3s;
}

.footer-section ul li a:hover { color: #1890ff; }

.footer-bottom {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.footer-bottom a {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.footer-bottom a:hover { color: #1890ff; }
.footer-bottom span { margin: 0 16px; }

/* ================= 响应式 ================= */
@media (max-width: 768px) {
  .privacy-section { padding: 24px 0; }
  .privacy-content { padding: 0 12px; }
  .privacy-content h1 { font-size: 22px; }
  .privacy-content h2 { font-size: 18px; margin-top: 24px; }
  .privacy-content h3 { font-size: 15px; }
  .privacy-content > p { font-size: 14px; text-indent: 0; }
  .version-info { font-size: 12px; }
  .container { padding: 0 12px; }
  .footer-section { padding: 24px 0; }
  .footer-bottom { font-size: 12px; }
  .footer-bottom span { margin: 0 8px; }
}

@media (max-width: 480px) {
  .privacy-content h1 { font-size: 18px; }
  .privacy-content h2 { font-size: 16px; }
  .privacy-content { padding: 0 8px; }
}
</style>
